import { Controller } from "@hotwired/stimulus"

// The signed-in Contact step's billing address (TMS-1808): choosing "Add a new address" shows its
// form; any saved address hides it, and its fields are disabled so they aren't posted.
export default class extends Controller {
  static targets = ["choice", "fields"]

  connect() {
    this.sync()
  }

  sync() {
    const adding = this.choiceTargets.find((input) => input.checked)?.value === "new"
    this.fieldsTarget.hidden = !adding
    this.fieldsTarget.querySelectorAll("input, button").forEach((field) => {
      // The state fields not matching the country stay as store-address left them.
      if (adding && field.closest("[hidden]") && field.closest("[hidden]") !== this.fieldsTarget) return
      field.disabled = !adding
    })
  }
}
